import React from 'react';
import PropTypes from 'prop-types';
import TweenOne from 'rc-tween-one';
import QueueAnim from 'rc-queue-anim';
import OverPack from 'rc-scroll-anim/lib/ScrollOverPack';

class Content extends React.Component {

  static propTypes = {
    className: PropTypes.string,
    id: PropTypes.string,
  };

  static defaultProps = {
    className: 'content5',
  };

  getBlockChildren = (item, i) =>
  (<li
    key={i}
    id={`${this.props.id}-block${i}`}
  >
    <span>
      <img src={item.img} width="100%" />
    </span>
    <h2>{item.title}</h2>
    <p>{item.content}</p>
  </li>);
  getBlockChildren1 = (item, i) =>
  (<li
    key={i}
    id={`${this.props.id}-block${i}`}
  >
    <span>
      <img src={item.img} width="100%" />
    </span>
    <h2>{item.title}</h2>
    <img src={item.contentImg} width="160px" height="160px" margin-left="35px"/>
  </li>);

  render() {
    const props = { ...this.props };
    const isMode = props.isMode;
    const dataSource = [
      { img: 'http://www.hooyee.xyz/images/tel.png', title: '服务热线', content: '010-82387768' },
      { img: 'http://www.hooyee.xyz/images/qq.svg', title: 'QQ', content: '76648182            3242346833' },
    ];
    const dataSource1=[
      { img: 'http://www.hooyee.xyz/images/weixin.svg', title: '微信公众号', content: '',contentImg:'http://www.hooyee.xyz/images/qrcode.jpg' },
    ];
    const ulChildren = dataSource.map(this.getBlockChildren);
    const ulChildren1 = dataSource1.map(this.getBlockChildren1);
    delete props.isMode;
    const queue = isMode ? 'bottom' : 'left';
    const imgAnim = isMode ? { y: 30, opacity: 0, delay: 400, type: 'from', ease: 'easeOutQuad' }
      : { x: 30, opacity: 0, type: 'from', ease: 'easeOutQuad' };
    return (
      <div {...props} className="content-template-wrapper content5-wrapper">
        <OverPack
          className={`content-template ${props.className}`}
          location={props.id}
          id='contact'
        >
          <QueueAnim
            className={`${props.className}-text`}
            key="text"
            type={queue}
            leaveReverse
            ease={['easeOutQuad', 'easeInQuad']}
            id={`${props.id}-textWrapper`}
          >
            <h1
              key="h1"
              id={`${props.id}-title`}
            >
              联系我们
            </h1>
            <p
              key="p"
              id={`${props.id}-content`}
            >
              提供多渠道优质客服通道
            </p>
            <QueueAnim
              component="ul"
              key="ul" type={queue}
              id={`${props.id}-ul`}
              ease="easeOutQuad"
            >
              {ulChildren}
              {ulChildren1}
            </QueueAnim>
          </QueueAnim>
          <TweenOne
            className={`${props.className}-img`}
            key="img"
            animation={imgAnim}
            id={`${props.id}-img`}
            resetStyleBool
          >
            <img width="100%" src="http://www.hooyee.xyz/images/contact.png" />
          </TweenOne>
        </OverPack>
      </div>
    );
  }
}


export default Content;



// WEBPACK FOOTER //
// ./src/Home/Content4.jsx